import { render } from "./content-drawer.vue?vue&type=template&id=4b2c626a"
import script from "./content-drawer.vue?vue&type=script&lang=js"
export * from "./content-drawer.vue?vue&type=script&lang=js"

import "./content-drawer.vue?vue&type=style&index=0&id=4b2c626a&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__